/* eslint-disable react/no-did-update-set-state */
/* global FB */
import PropTypes from 'prop-types'
import { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import _ from 'lodash'
import { postStateSelector as stateSelector } from 'reduxModules/blogPosts/selectors'
import { blogPostDispatchers as dispatchers } from 'reduxModules/blogPosts/dispatchers'
import { blogPostStatus } from 'reduxModules/blogPosts'
import AssetGalleryPropTypes from 'components/generic/AssetsGallery/propTypes'

import template from './template.rt'
import './styles.css'

const SCROLL_PERCENTAGE_TO_DISPLAY_LM_FUNNEL = 40
export class Post extends Component {
  constructor(props) {
    super(props)
    this.routerWillLeave = this.routerWillLeave.bind(this)
    this.onCloseLeadMagnetDialog = this.onCloseLeadMagnetDialog.bind(this)
  }

  componentDidMount() {
    this.props.loadBlogPostDetail()
    this.props.loadAdBanners({ quantity: 1 })
    this.props.resetLeadMagnetDialog()

    const { router, route } = this.props
    if (_.has(router, 'setRouteLeaveHook'))
      router.setRouteLeaveHook(route, this.routerWillLeave)
  }

  componentDidUpdate(prevProps) {
    const oldSlug = prevProps.params.postSlug
    const newSlug = this.props.params.postSlug
    if (oldSlug !== newSlug) {
      this.props.loadBlogPostDetail()
      this.props.loadAdBanners({ quantity: 1 })
      this.props.resetLeadMagnetDialog()
    }

    const oldScrollPercentage = prevProps.scrollPercentage
    const newScrollPercentage = this.props.scrollPercentage
    if (
      oldScrollPercentage !== newScrollPercentage &&
      newScrollPercentage > SCROLL_PERCENTAGE_TO_DISPLAY_LM_FUNNEL
    )
      this.props.displayLeadMagnetDialog()
  }

  componentWillUnmount() {
    this.props.clearBlog()
  }

  routerWillLeave(nextLocation) {
    const { triggerPendingScroll } = this.props

    if (nextLocation.pathname === '/blog') triggerPendingScroll()
    return true
  }

  onCloseLeadMagnetDialog() {
    this.props.hideLeadMagnetDialog()
  }

  render() {
    if (this.props.requestDetailStatus === blogPostStatus.success)
      return template.call(this)
    return null
  }
}

Post.propTypes = {
  requestDetailStatus: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  orderDate: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
  photo: PropTypes.objectOf(PropTypes.string),
  tags: PropTypes.arrayOf(PropTypes.string).isRequired,
  assets: PropTypes.arrayOf(PropTypes.shape(AssetGalleryPropTypes)).isRequired,

  /* Dispatchers */
  loadBlogPostDetail: PropTypes.func.isRequired,
  clearBlog: PropTypes.func.isRequired,
  loadAdBanners: PropTypes.func.isRequired,
  params: PropTypes.objectOf(PropTypes.string).isRequired
}

Post.defaultProps = {
  title: '',
  description: '',
  created: '',
  orderDate: '',
  body: '',
  tags: [],
  photo: {},
  assets: [],
  loadAdBanners: () => []
}

export default connect(
  stateSelector,
  dispatchers
)(withRouter(Post))
